import useSWR from 'swr';

import { Project } from 'models';
import { ProjectHelpers } from 'helpers/ProjectHelpers';

import { ProjectUserService } from 'services/ProjectUserService';

const useProjectUsers = (projectId?: Project['id'] | null) => {
    const key = projectId ? ProjectHelpers.swr.users(projectId) : null;
    const { data: projectUsers = [], ...swr } = useSWR(key, () => ProjectUserService.list(projectId!));

    return { ...swr, projectUsers };
};

export { useProjectUsers };
